module.exports = __webpack_public_path__ + "static/media/designsprint.61387d55.md";